import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Button from '../UI/Button/Button';
import HeadingH3 from '../UI/Headings/HeadingH3/HeadingH3';
import fareIncreasedImage from './img/fare-increased.png';
import fareDecreasedImage from './img/fare-decreased.png';

import * as uiActions from '../../store/actions/index';

const fareAlert = (props) => (
    <div style={{transform: props.diff !== 0 && !props.hideFareAlert ? 'translateX(0)' : 'translateX(100%)'}} className={`u-width100Percent u-height100Percent u-fixed u-transition--transform200Spring phone-pt-0 u-backgroundColorWhite u-zIndex9`}>
        <div className={`pt-12 pl-6 pr-6 pb-4 u-flex f-column justify-content-between u-backgroundColorWhite u-height100Percent phone-p-4`}>
            <div>
                <div className={`mb-3`}>
                    <HeadingH3 size={16} weight="Medium" color="Dark">{props.diff > 0 ? 'Fare Increased' : 'Fare Decreased'}</HeadingH3>
                </div>
                <div>
                    <p className={`u-textColorNormal`}>The Airline has {props.diff > 0 ? 'icreased' : 'decreased'} the fare on this route by <span className={`u-textColorDark u-fontWeightMedium`}>&#8377;{props.diff.toLocaleString()}</span>. Please note that airfares are dynamic and subject to change.</p>
                </div>
            </div>
            <div className={`u-phoneTextAlignCenter`}>
                {props.diff < 0 ? <img src={fareDecreasedImage} alt="Fare Decreased" /> : <img src={fareIncreasedImage} alt="Fare Increased" /> }
            </div>
            <div>
                <p className={`u-flex justify-content-between mb-3 phone-mb-2 u-textColorDark`}>
                    <span>Updated Fare</span>
                    <span className={`u-fontSize16`}>&#8377;{(props.diff + props.totalFare).toLocaleString()}</span>
                </p>
                <p className={`u-flex justify-content-between u-textColorDark`}>
                    <span>Original Fare</span>
                    <span className={`u-fontSize16`}>&#8377;{props.totalFare.toLocaleString()}</span>
                </p>
            </div>
            <div className={'u-height1 u-width100Percent u-block u-backgroundColorDarkGrey'}></div>
            <div> 
                <p className={`u-flex justify-content-between u-textUppercase u-fontSize16 u-fontWeightMedium`}>
                    <span className={`u-textColorDark`}>Difference</span>
                    <span style={{color: props.diff < 0 ? '#11993C' : '#F46262'}}>{props.diff > 0 ? '+' : '-'} &#8377;{Math.abs(props.diff).toLocaleString()}</span>
                </p>
            </div>
            <div className={`u-width100Percent u-boxShadowNormal p-2`}>
                <p className={`u-fontSize11 u-textColorNormal`}><span className={`u-textColorDark u-fontWeightMedium`}>Note:</span> The Fare Rules for your flight selection have changed. Please review them before proceeding.</p>
            </div>
            <div>
                <div className={`mb-4`}>
                    <Button onClick={() => props.onHideFareAlert()} theme='Primary' width='Block' type='Search'>Continue</Button>
                </div>
                <div className={`u-textAlignCenter`}><p onClick={() => props.history.goBack()} className={`u-textColorPrimary u-cursorPointer u-inlineBlock u-textUppercase u-fontWeightMedium`}>Change Flight</p></div>
            </div>
        </div>
    </div>
);

const mapStateToProps = state => {
    return {
        diff: state.farePrice.generalData.diff,
        totalFare: state.farePrice.totalFare,
        hideFareAlert: state.ui.hideFareAlert
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onHideFareAlert: () => dispatch(uiActions.hideFareAlert())
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(fareAlert));


// WEBPACK FOOTER //
// ./src/components/FareAlert/FareAlert.js